import React, { useMemo } from 'react';
import InView from 'react-intersection-observer';
import Checkbox from '@zvuk-b2b/react-uikit/ui/Checkbox';
import { DATA_TEST_IDS, MEDIAFILE_SELECTION_SKELETON_COUNT } from '../consts';
import { TEXTS } from '../texts';
import type { ChooseItemListType } from './types';
import styles from './index.module.scss';
import VideoStreamPreviewItem from './VideoMediafilePreviewItem';

const SelectVideoMediafilesList: React.FC<ChooseItemListType> = ({
  itemList,
  onChange,
  isLoading,
  selectedItems,
  loadMore,
  paginationSettings,
  isReloading,
  emptySearchText,
  onRetry,
  onRemoveUpload,
}) => {
  const selectedSet = useMemo(() => new Set(selectedItems.map((item) => item.id)), [selectedItems]);
  const skeletonCount = isLoading || paginationSettings?.hasNextPage ? MEDIAFILE_SELECTION_SKELETON_COUNT : 0;

  return (
    <>
      {itemList?.map((item) => (
        <div
          key={item.id}
          className={styles.row}
          data-testid={DATA_TEST_IDS.MEDIAFILE_SELECTION_ROW}>
          <VideoStreamPreviewItem
            file={item}
            onRetry={onRetry}
            onRemoveUpload={onRemoveUpload}
            leading={
              <Checkbox
                elementId={DATA_TEST_IDS.MEDIAFILE_SELECTION_CHECKBOX(item.id ?? '')}
                labelClassName={styles.checkboxLabel}
                isChecked={selectedSet.has(item.id)}
                isDisabled={isReloading || isLoading || Boolean(item.uploadState) || item.uploading}
                onChange={(value) => onChange(value, item)}>
                {TEXTS.SELECT_MEDIAFILE(item.title ?? '')}
              </Checkbox>
            }
          />
        </div>
      ))}
      {itemList?.length === 0 && !isLoading && <div className={styles.SearchItemsEmpty}>{emptySearchText}</div>}
      <InView
        skip={isLoading || !paginationSettings?.hasNextPage}
        onChange={(inView) => {
          if (inView && !isLoading) loadMore?.();
        }}>
        {Array.from({ length: skeletonCount }, (_, index) => (
          <div
            key={index}
            className={styles.row}
            data-testid={DATA_TEST_IDS.MEDIAFILE_SELECTION_SKELETON}>
            <VideoStreamPreviewItem />
          </div>
        ))}
      </InView>
    </>
  );
};

export default SelectVideoMediafilesList;
